<template>
  <div>
      <div class="contents-row">
        <!-- 타이틀 시작 -->
        <div class="page-title-1depth">
          <span class="page-title-1depth-text">{{$t('sm.adminGroupSettings_page_deviceGroupSetting')}}</span>
        </div>
        <div v-if="checkInhritView"
             class="contents-title-option-group">
          <q-radio @input="onInput" v-model="adminGeneral.admin_device_inhrit_yn"
                   val="1" color="primary" :label="this.$t('sm.adminGroupSettings_page_admin_inhrit_yn1')" class="bs bs-q-radio bs-q-radio-square" :disable="isReadOnly || fnIsSuper">
          </q-radio>
          <q-radio @input="onInput" v-model="adminGeneral.admin_device_inhrit_yn"
                   val="0" color="primary" :label="this.$t('sm.adminGroupSettings_page_admin_inhrit_yn2')" class="bs bs-q-radio bs-q-radio-square" :disable="isReadOnly || fnIsSuper" >
          </q-radio>
        </div>
        <!-- 타이틀 끝 -->
      </div>
      <div class="portlet">
        <div class="contents-row" v-if="isPathView">
          <table class="bs-table table-bordered-none">
            <colgroup>
              <col width="20%"/>
              <col width="auto"/>
            </colgroup>
            <tbody>
              <tr>
                <td class="td-head">{{$t('cmn.select')}}</td>
                <td>
                  <div class="inline-group"><!-- class="block-group"은 세로 정렬 / class="inline-group"은 가로 정렬 -->
                    <q-input v-model="pathName" class="bs bs-q-input bs-q-input-default" style="width:100%;" disable />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>


        </div>
        <div class="contents-row">
          <!-- <device-tree  ref="deviceTree"
                        :defaultClass="['pro']"
                        :heightCss="heightCss"
                        :title="''"
                        mode="group"
                        :search="false"
                        :tickStrategy="tickStrategy"
                        @treeClick="onTreeClick"
          ></device-tree> -->
          <!-- 테이블 시작 -->
          <div class="contents-row collapsible-fullH  ps-q-treeBlock no-border">
            <q-list inset-separator class="bs bs-q-collapsible bs-q-collapsible-fullH borderColorGray">
              <q-tree ref="deviceTree"
                      :nodes="adminDeviceTree"
                      node-key="device_id"
                      :selected.sync="selected"
                      :dark="dark"
                      :filter="filter"
                      :tick-strategy="tickStrategy"
                      :ticked.sync="deviceTicked"
                      :expanded.sync="expanded"
                      :defaultExpandAll="defaultExpandAll"
                      class="ps-q-tree ps-q-tree-square"
                      style="minHeight: 200px;"
                    >
                <div slot="header-custom" slot-scope="prop" class="row items-center">
                  <div>
                    {{prop.node.label}}

                  </div>
                </div>
              </q-tree>
            </q-list>
          </div>
          <!-- 테이블 끝 -->
        </div>
      </div>
      <loading-dialog ref="loadingPopup">
      </loading-dialog>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import AlertDialog from '~/components/dialog/AlertDialog'
  import LoadingDialog from '~/components/dialog/LoadingDialog'
  const storeAdminGroupSettings = createNamespacedHelpers('system/adminSettings/adminGroupSettings')

  export default {
    name: 'adminDeviceGroup',
    components: {
      // DeviceTree,
      AlertDialog,
      LoadingDialog
    },
    props: {
      // 미사용
      heightCss: {
        type: String,
        default: '190px'
      },
      fnIsSuper: {
        type: Boolean,
        default: false
      },
      // 관리자별 관리장비 그룹편집
      isPathView: {
        type: Boolean,
        default: false
      },
      pathName: {
        type: String,
        default: 'Prism'
      },
      isReadOnly: {
        type: Boolean,
        default: false
      },
      externalAuth: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...storeAdminGroupSettings.mapState([
        'adminGeneral',
        'adminDeviceCur',
        'adminDeviceParent',
        'adminDeviceTree',
        'adminDeviceExpanded'
      ]),
      checkInhritView () {
        return this.adminGeneral.parent_admin_id !== null && this.adminGeneral.admin_type !== 2 && this.adminGeneral.admin_type !== 3 && !this.externalAuth
      }
    },
    data () {
      return {
        option: null,
        terms: null,
        pageIndex: 1,
        pageSize: 15,
        page: 1,
        filter: null,
        // 'none', 'strict', 'leaf', 'leaf-filtered'
        tickStrategy: 'strict',
        deviceTicked: [],
        selectableNodes: true,
        dark: false,
        accordion: true,
        selected: null,
        expanded: null,
        defaultExpandAll: true
      }
    },
    created () {},
    methods: {
      ...storeAdminGroupSettings.mapActions([
        'acsDeviceTree',
        'acsPostManagersDevice',
        'acsManagersGroupUnload'
      ]),
      onSave () {
        this.$emit('onSave')
      },
      async onInput () {
        this.getDeviceTicked()
        if (this.adminGeneral.admin_device_inhrit_yn === '1') {
          await this.putSeletedData()
        }
      },
      async putSeletedData () {
        const param = {admin_device_inhrit_yn: 1}
        // 체크가 있을경우 submit
        if (this.deviceTicked.length > 0) {
          this.$refs.loadingPopup.show()
          let result = await this.acsPostManagersDevice({admin_id: this.adminGeneral.admin_id, device: param})
          if (result.code !== 'ok') {
            this.$refs.loadingPopup.hide()
            this.$alertPopUp.show(result.errors)
          }
          result = await this.acsManagersGroupUnload(this.adminGeneral.admin_id)
          if (result.code !== 'ok') {
            this.$refs.loadingPopup.hide()
            this.$alertPopUp.show(result.errors)
          }
          this.$refs.loadingPopup.hide()
        }
      },
      // 디바이스 체크 목록
      getDeviceTicked (val) {
        let val2 = null
        val2 = val
        if (val === undefined) {
          val2 = this.adminDeviceParent
        }
        if ((this.adminDeviceTree !== undefined && this.isReadOnly) ||
          (this.adminDeviceTree !== undefined && this.adminGeneral.admin_device_inhrit_yn === '1')) {
          this.adminDeviceTree.forEach(item => {
            item.disabled = true
          })
        } else {
          this.adminDeviceTree.forEach(item => {
            item.disabled = null
          })
        }
        // if (val === undefined) {
        //   val2 = this.$refs.deviceTree.orgDeviceTreeData
        // }
        // if (this.$refs.deviceTree.deviceTreeData !== undefined) {
        //   this.$refs.deviceTree.deviceTreeData.forEach(item => {
        //     if (this.adminGeneral.admin_device_inhrit_yn === '1') {
        //       item.disabled = true
        //     } else {
        //       item.disabled = null
        //     }
        //   })
        // }
        // if (this.adminGeneral.admin_device_inhrit_yn === '1') {
        //   this.deviceTicked = val2.map((item) => {
        //     return item.device_id
        //   })
        // } else if (this.adminGeneral.admin_device_inhrit_yn === '0') {
        // #30449 - [System - 관리자 설정] 관리장비 그룹 편집 > 관리자 Tree에서 특정 그룹 개별 속성 사용 변경시 하위 사용자에게 적용 안되는 문제
        if (this.adminDeviceCur.length > 0) {
          this.deviceTicked = this.adminDeviceCur.map((item) => {
            return item.device_id
          })
        } else {
          this.deviceTicked = val2.map((item) => {
            return item.device_id
          })
        }
      }
      // }
    },
    watch: {
      adminDeviceParent (val) {
        this.getDeviceTicked(val)
      },
      adminDeviceExpanded (val) {
        this.expanded = val
      // },
      // $refs: {
      //   deviceTree: {
      //     orgDeviceTreeData (val) {
      //       this.getDeviceTicked(val)
      //     },
      //     deviceExpanded (val) {
      //       this.expanded = val
      //     }
      //   }
      }
    }
  }
</script>
